import { Component, Input } from '@angular/core';
import { SharedModule } from 'app/shared.module';

@Component({
  selector: 'app-kpi-card',
  templateUrl: './kpi-card.component.html',
  styleUrls: ['./kpi-card.component.scss'],
  standalone: true,
  imports: [SharedModule]
})
export class KpiCardComponent {

  @Input() icon!: string;
  @Input() iconColor = 'var(--color-primary-500)';

  @Input() title!: string;
  @Input() value!: string;

  @Input() footerIcon?: string;
  @Input() footerText?: string;

}
